<template>
  <div>
    <input
      id="message[customer_id]"
      v-model="selectedCustomerId"
      type="hidden"
      name="message[customer_id]"
    />
    <div class="clinic-message-form__customer-input-block">
      <input
        v-model="keyword"
        type="text"
        name="customer_name"
        :readonly="customerSelected"
        :placeholder="placeholder"
        class="clinic-message-form__customer-input"
        :class="{ 'clinic-message-form__customer-input--error': hasError }"
        autocomplete="off"
        @keydown.enter="searchCustomer"
        @input="checkKeywordLength"
      />
      <!-- 送信先選択済の場合は以下のボタンで飼い主の名前を表示 -->
      <button
        v-show="customerSelected"
        type="button"
        class="clinic-message-form__selected-customer-name-icon"
      >
        {{ selectedCustomerNameValue }}
      </button>
      <!-- 送信先選択済の場合は以下のリセットボタンを表示 -->
      <button
        v-show="customerSelected"
        type="button"
        class="clinic-message-form__customer-change-btn"
        @click="resetCustomer"
      >
        <i
          class="fa fa-times-circle-o clinic-message-form__customer-change-btn-icon"
          aria-hidden="true"
        ></i>
        キャンセル
      </button>
      <!-- キーワードで検索した結果を以下のテーブルで表示 -->
      <table v-show="showCustomerList" class="clinic-message-form__customer-list-table">
        <thead>
          <tr class="clinic-message-form__customer-list-table-header-row">
            <th class="clinic-message-form__customer-list-table-header">飼主名</th>
            <th class="clinic-message-form__customer-list-table-header">電話番号</th>
            <th class="clinic-message-form__customer-list-table-header">ペット名</th>
            <th class="clinic-message-form__customer-list-table-header">診察券番号</th>
            <th class="clinic-message-form__customer-list-table-header">種別</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="customer in searchedCustomers"
            :key="customer.value"
            class="clinic-message-form__customer-list-tbody-tr"
            @click="selectCustomer(customer)"
          >
            <td class="clinic-message-form__customer-list-tbody-td">{{ customer.name }}</td>
            <td class="clinic-message-form__customer-list-tbody-td">{{ customer.tel }}</td>
            <td class="clinic-message-form__customer-list-tbody-td">
              <div
                v-for="customer_pet in customer.customer_pets"
                :key="customer_pet.value"
                class="clinic-message-form__customer-list-tbody-pet-info-name"
              >
                <span>{{ customer_pet.name }}</span>
                <img v-if="customer_pet.dead" :src="heavenImg" height="19" />
              </div>
            </td>
            <td class="clinic-message-form__customer-list-tbody-td">
              <span
                v-for="customer_pet in customer.customer_pets"
                :key="customer_pet.value"
                class="clinic-message-form__customer-list-tbody-pet-info"
                >{{ customer_pet.patient_card_number }}</span
              >
            </td>
            <td class="clinic-message-form__customer-list-tbody-td">
              <span
                v-for="customer_pet in customer.customer_pets"
                :key="customer_pet.value"
                class="clinic-message-form__customer-list-tbody-pet-info"
                >{{ customer_pet.klass }}</span
              >
            </td>
          </tr>
          <tr v-if="searchedCustomers.length == 0">
            <td class="clinic-message-form__customer-list-tbody-td" colspan="5">該当なし</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      type="button"
      :disabled="customerSelected"
      class="clinic-message-form__customer-search-btn"
      @click="searchCustomer"
    >
      検索
    </button>
  </div>
</template>

<script>
import { axios } from '@v2/utils/httpRequest.js';
import heavenImg from '@assets/images/v2/u/pets/heaven.png';

export default {
  props: {
    originalCustomerId: String,
    selectedCustomerName: String,
    hasError: Boolean,
  },
  data() {
    return {
      keyword: '',
      showCustomerList: false,
      selectedCustomerId: null,
      clinicCustomers: [],
      searchedCustomers: [],
      selectedCustomerNameValue: this.selectedCustomerName,
      heavenImg: heavenImg,
    };
  },
  computed: {
    customerSelected() {
      return this.selectedCustomerId != null;
    },
    placeholder() {
      if (!this.customerSelected) {
        return '\uf002  氏名、氏名カナ、ペット名、診察券番号、電話番号';
      }
      return '';
    },
  },
  created() {
    if (this.originalCustomerId != '') {
      this.selectedCustomerId = Number(this.originalCustomerId);
    }
    axios
      .get('/api/v1/clinic/customers')
      .then((response) => {
        this.clinicCustomers = response.data.customers;
      })
      .catch(() => {
        this.$swal('通信エラーが発生しました');
      });
  },
  methods: {
    checkKeywordLength: function () {
      if (this.keyword.length == 0) {
        this.showCustomerList = false;
      }
    },
    searchCustomer: function () {
      if (this.keyword.trim().length > 0) {
        this.searchedCustomers = this.clinicCustomers.filter((customer) =>
          this.isSearchedByKeyword(customer),
        );
        this.showCustomerList = true;
      }
    },
    selectCustomer: function (customer) {
      this.showCustomerList = false;
      this.keyword = '';
      this.selectedCustomerId = customer.id;
      this.selectedCustomerNameValue = customer.name;
    },
    resetCustomer: function () {
      this.selectedCustomerId = null;
      this.selectedCustomerNameValue = null;
    },
    isSearchedByKeyword: function (customer) {
      let keyword = this.keyword.trim();
      if (customer.name.indexOf(keyword) !== -1) {
        return true;
      }
      if (customer.name_kana.indexOf(keyword) !== -1) {
        return true;
      }
      if (customer.tel.startsWith(keyword)) {
        return true;
      }
      let customer_pets = customer.customer_pets;
      for (let i = 0; i < customer_pets.length; i++) {
        let pet = customer_pets[i];
        if (pet.name.indexOf(keyword) !== -1) {
          return true;
        }
        if (pet.patient_card_number && pet.patient_card_number.startsWith(keyword)) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
